define('lq/required',[
    'jquery',
    'underscore'
], function ($, _) {
    'use strict';

    var Required = function () {
    };

    Required.prototype.apply = function (drop, callBack) {
        if (drop.data.required.isRequired) {
            if (this.fromQuery(drop)) {
                // Initializing
                drop.requiredData = !!drop.data.required.initialVisibility;
                drop.piping.datasources.registerDatasourceListener(
                    drop.data.required.datasource,
                    function (data) {
                        var isRequired = data.results.length && data.results[0][drop.data.required.datasourceOutput];
                        if (isRequired === true) {
                            drop.$element.addClass('isRequiredField');
                            drop.requiredData = true;
                        } else {
                            drop.$element.removeClass('isRequiredField');
                            drop.requiredData = false;
                        }

                        drop.updateRequiredIndicator();
                        if ((typeof callBack) === 'function')
                            callBack(drop.requiredData);
                    }
                );
            } else if (this.fromParameter(drop)) {
                if (this.valueFromParameterIsTrue(drop)) {
                    drop.$element.addClass('isRequiredField');
                    drop.requiredData = true;
                }
                else {
                    drop.$element.removeClass('isRequiredField');
                    drop.requiredData = false;
                }
            } else { // Hardcoded case
                drop.requiredData = true;
            }
            if (drop.data.defaultValue) {
                setTimeout(function () {
                    drop.updateRequiredIndicator();
                });
            }
        } else {
            drop.requiredData = false;
        }
        if ((typeof callBack) === 'function')
            callBack(drop.requiredData);
    };

    // note that this is a very naive implementation. It can use parameters that are passed in from another page,
    // but it won't be able to pick up parameters that are set during the PageLoad event or any other event.
    // If we need to support that second use case, we need to be able to listen to changes to parameter values
    Required.prototype.valueFromParameterIsTrue = function (drop) {
        var value = drop.piping.parameters.getValue(drop.data.required.parameter);

        if ($.type(value) === 'boolean')
            return value === true;

        if ($.type(value) === 'string')
            return value.toLowerCase() === 'true';

        return !!drop.data.required.initialVisibility;
    };

    Required.prototype.addRemoveRequiredIndicator = function (drop) {
        if (!this.fromParameter(drop)) {
            if (drop.data.required.isRequired && (this.fromHardcoded(drop) || drop.designData || drop.data.required.initialVisibility))
                drop.$element.addClass('isRequiredField');
            else
                drop.$element.removeClass('isRequiredField');
        }
    };

    Required.prototype.fromQuery = function (drop) {
        return drop.data.required.valueSource === 'query' && drop.data.required.datasource;
    };

    Required.prototype.fromParameter = function (drop) {
        return drop.data.required.valueSource === 'parameter';
    };

    Required.prototype.fromHardcoded = function (drop) {
        return drop.data.required.valueSource === 'hardcoded';
    };

    return Required;
});

